import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { LoggedUser } from '@/api/auth/types/LoggedUser'
import { updateNotificationPreferences } from '@/api/user/deviceTokenService'
import { QUERY_KEYS } from '@/lib/queryKeys'

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateNotificationPreferences,
    onSuccess: prefs => {
      queryClient.setQueryData<LoggedUser>([QUERY_KEYS.LOGGED_USER], prev => (prev ? { ...prev, notificationPreferences: prefs } : prev))
    },
  })
}
